import styled from "styled-components";

const Container = styled.div`
	margin: 0 auto;
    width: fit-content;
`;

const CustomMainContent = ({ children }) => {
    return <Container className="py-5 pl-5">{children}</Container>;
};

export default CustomMainContent;
